const Astrology = (() => {
  const RASHI_DATA = [
    { id: "mesha",      name: "メーシャ",       nameJp: "牡羊座", ruler: "Mars",    element: "火", benefics: ["Sun", "Jupiter"] },
    { id: "vrishabha",  name: "ヴリシャバ",     nameJp: "牡牛座", ruler: "Venus",   element: "地", benefics: ["Saturn", "Mercury"] },
    { id: "mithuna",    name: "ミトゥナ",       nameJp: "双子座", ruler: "Mercury", element: "風", benefics: ["Venus", "Saturn"] },
    { id: "karka",      name: "カルカ",         nameJp: "蟹座",   ruler: "Moon",    element: "水", benefics: ["Mars", "Jupiter"] },
    { id: "simha",      name: "シンハ",         nameJp: "獅子座", ruler: "Sun",     element: "火", benefics: ["Mars", "Jupiter"] },
    { id: "kanya",      name: "カンヤ",         nameJp: "乙女座", ruler: "Mercury", element: "地", benefics: ["Venus"] },
    { id: "tula",       name: "トゥラー",       nameJp: "天秤座", ruler: "Venus",   element: "風", benefics: ["Saturn", "Mercury"] },
    { id: "vrishchika", name: "ヴリシュチカ",   nameJp: "蠍座",   ruler: "Mars",    element: "水", benefics: ["Moon", "Jupiter"] },
    { id: "dhanu",      name: "ダヌ",           nameJp: "射手座", ruler: "Jupiter", element: "火", benefics: ["Sun", "Mars"] },
    { id: "makara",     name: "マカラ",         nameJp: "山羊座", ruler: "Saturn",  element: "地", benefics: ["Venus", "Mercury"] },
    { id: "kumbha",     name: "クンバ",         nameJp: "水瓶座", ruler: "Saturn",  element: "風", benefics: ["Venus"] },
    { id: "meena",      name: "ミーナ",         nameJp: "魚座",   ruler: "Jupiter", element: "水", benefics: ["Moon", "Mars"] },
  ];

  // Vedic (sidereal) sun sign date ranges - approximate, based on Lahiri ayanamsa
  const RASHI_DATES = [
    { index: 0,  startMonth: 4,  startDay: 14, endMonth: 5,  endDay: 14 },  // Mesha
    { index: 1,  startMonth: 5,  startDay: 15, endMonth: 6,  endDay: 14 },  // Vrishabha
    { index: 2,  startMonth: 6,  startDay: 15, endMonth: 7,  endDay: 16 },  // Mithuna
    { index: 3,  startMonth: 7,  startDay: 17, endMonth: 8,  endDay: 16 },  // Karka
    { index: 4,  startMonth: 8,  startDay: 17, endMonth: 9,  endDay: 16 },  // Simha
    { index: 5,  startMonth: 9,  startDay: 17, endMonth: 10, endDay: 16 },  // Kanya
    { index: 6,  startMonth: 10, startDay: 17, endMonth: 11, endDay: 15 },  // Tula
    { index: 7,  startMonth: 11, startDay: 16, endMonth: 12, endDay: 15 },  // Vrishchika
    { index: 8,  startMonth: 12, startDay: 16, endMonth: 1,  endDay: 13 },  // Dhanu (crosses year)
    { index: 9,  startMonth: 1,  startDay: 14, endMonth: 2,  endDay: 12 },  // Makara
    { index: 10, startMonth: 2,  startDay: 13, endMonth: 3,  endDay: 14 },  // Kumbha
    { index: 11, startMonth: 3,  startDay: 15, endMonth: 4,  endDay: 13 },  // Meena
  ];

  const PLANET_NAMES_JP = {
    Sun:     "太陽（スーリヤ）",
    Moon:    "月（チャンドラ）",
    Mars:    "火星（マンガラ）",
    Mercury: "水星（ブダ）",
    Jupiter: "木星（グル）",
    Venus:   "金星（シュクラ）",
    Saturn:  "土星（シャニ）",
    Rahu:    "ラーフ",
    Ketu:    "ケートゥ",
  };

  function getRashi(month, day) {
    for (const range of RASHI_DATES) {
      if (range.startMonth <= range.endMonth) {
        if (
          (month === range.startMonth && day >= range.startDay) ||
          (month === range.endMonth && day <= range.endDay) ||
          (month > range.startMonth && month < range.endMonth)
        ) {
          return RASHI_DATA[range.index];
        }
      } else {
        // Crosses year boundary (Dhanu: Dec 16 - Jan 13)
        if (
          (month === range.startMonth && day >= range.startDay) ||
          (month === range.endMonth && day <= range.endDay) ||
          month > range.startMonth ||
          month < range.endMonth
        ) {
          return RASHI_DATA[range.index];
        }
      }
    }
    return RASHI_DATA[0];
  }

  function approximateLagna(rashiIndex, timeBlock) {
    if (!timeBlock) return null;

    const offsets = {
      // Simple 3-block
      morning: 1, afternoon: 4, evening: 8,
      // Detailed 2-hour blocks (sunrise ~6am = offset 0 from Rashi)
      h6: 0, h8: 1, h10: 2, h12: 3, h14: 4, h16: 5,
      h18: 6, h20: 7, h22: 8, h0: 9, h2: 10, h4: 11,
    };

    const offset = offsets[timeBlock];
    if (offset === undefined) return null;
    const lagnaIndex = (rashiIndex + offset) % 12;
    return RASHI_DATA[lagnaIndex];
  }

  // Default planet priority for tiebreaking (higher index = lower priority)
  const PLANET_PRIORITY = ["Sun", "Jupiter", "Mars", "Venus", "Mercury", "Moon", "Saturn", "Rahu", "Ketu"];

  function recommend(month, day, timeBlock) {
    const rashi = getRashi(month, day);
    const rashiIndex = RASHI_DATA.indexOf(rashi);
    const lagna = approximateLagna(rashiIndex, timeBlock);

    const scores = {};
    const allPlanets = ["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn", "Rahu", "Ketu"];
    allPlanets.forEach(p => scores[p] = 0);

    // Rashi ruler: weight 3
    scores[rashi.ruler] += 3;

    // Lagna ruler: weight 2
    if (lagna) {
      scores[lagna.ruler] += 2;
    }

    // Benefic planets for this Rashi: weight 1
    rashi.benefics.forEach(p => scores[p] += 1);

    // Sort planets by score descending, break ties by default planet priority
    const ranked = allPlanets
      .map(p => ({ planet: p, score: scores[p] }))
      .sort((a, b) => {
        if (b.score !== a.score) return b.score - a.score;
        return PLANET_PRIORITY.indexOf(a.planet) - PLANET_PRIORITY.indexOf(b.planet);
      });

    const topPlanet = ranked[0].planet;
    const secondPlanet = ranked[1] && ranked[1].score > 0 ? ranked[1].planet : null;
    const thirdPlanet = ranked[2] && ranked[2].score > 0 ? ranked[2].planet : null;

    return {
      rashi,
      lagna,
      topPlanet,
      secondPlanet,
      thirdPlanet,
      scores,
      planetNameJp: PLANET_NAMES_JP[topPlanet],
    };
  }

  // Exaltation/debilitation rashiIndex for each planet
  const EXALTATION = { Sun: 0, Moon: 1, Mars: 9, Mercury: 5, Jupiter: 3, Venus: 11, Saturn: 6 };
  const DEBILITATION = { Sun: 6, Moon: 7, Mars: 3, Mercury: 11, Jupiter: 9, Venus: 5, Saturn: 0 };

  function recommendFromPositions(planets, lagna) {
    // Vedic (Jyotisha) uses the Moon's rashi (Janma Rashi) as the person's
    // primary sign, not the Sun's. The Sun sign is a Western convention.
    const moonRashiIndex = planets.Moon.rashiIndex;
    const rashi = RASHI_DATA[moonRashiIndex];
    const lagnaRashi = lagna ? RASHI_DATA[lagna.rashiIndex] : null;

    const scores = {};
    const allPlanets = ["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn", "Rahu", "Ketu"];
    allPlanets.forEach(p => scores[p] = 0);

    // Rashi ruler: weight 3
    scores[rashi.ruler] += 3;

    // Lagna ruler: weight 2
    if (lagnaRashi) {
      scores[lagnaRashi.ruler] += 2;
    }

    // Benefic planets: weight 1
    rashi.benefics.forEach(p => scores[p] += 1);

    // Exaltation/debilitation bonus
    allPlanets.forEach(p => {
      if (!planets[p]) return;
      const ri = planets[p].rashiIndex;
      if (EXALTATION[p] !== undefined && ri === EXALTATION[p]) scores[p] += 1;
      if (DEBILITATION[p] !== undefined && ri === DEBILITATION[p]) scores[p] -= 1;
    });

    const ranked = allPlanets
      .map(p => ({ planet: p, score: scores[p] }))
      .sort((a, b) => {
        if (b.score !== a.score) return b.score - a.score;
        return PLANET_PRIORITY.indexOf(a.planet) - PLANET_PRIORITY.indexOf(b.planet);
      });

    const topPlanet = ranked[0].planet;
    const secondPlanet = ranked[1] && ranked[1].score > 0 ? ranked[1].planet : null;
    const thirdPlanet = ranked[2] && ranked[2].score > 0 ? ranked[2].planet : null;

    return {
      rashi,
      lagna: lagnaRashi,
      topPlanet,
      secondPlanet,
      thirdPlanet,
      scores,
      planetNameJp: PLANET_NAMES_JP[topPlanet],
    };
  }

  // ============================================================
  // Nakshatra (27 lunar mansions)
  // ============================================================
  const NAKSHATRA_DATA = [
    { name: "Ashwini",          nameJp: "アシュヴィニー",         lord: "Ketu"    },
    { name: "Bharani",          nameJp: "バラニー",               lord: "Venus"   },
    { name: "Krittika",         nameJp: "クリッティカー",         lord: "Sun"     },
    { name: "Rohini",           nameJp: "ローヒニー",             lord: "Moon"    },
    { name: "Mrigashira",       nameJp: "ムリガシラー",           lord: "Mars"    },
    { name: "Ardra",            nameJp: "アールドラー",           lord: "Rahu"    },
    { name: "Punarvasu",        nameJp: "プナルヴァス",           lord: "Jupiter" },
    { name: "Pushya",           nameJp: "プシュヤ",               lord: "Saturn"  },
    { name: "Ashlesha",         nameJp: "アーシュレーシャー",     lord: "Mercury" },
    { name: "Magha",            nameJp: "マガー",                 lord: "Ketu"    },
    { name: "Purva Phalguni",   nameJp: "プールヴァ・ファルグニー",   lord: "Venus"   },
    { name: "Uttara Phalguni",  nameJp: "ウッタラ・ファルグニー",     lord: "Sun"     },
    { name: "Hasta",            nameJp: "ハスタ",                 lord: "Moon"    },
    { name: "Chitra",           nameJp: "チトラー",               lord: "Mars"    },
    { name: "Swati",            nameJp: "スヴァーティー",         lord: "Rahu"    },
    { name: "Vishakha",         nameJp: "ヴィシャーカー",         lord: "Jupiter" },
    { name: "Anuradha",         nameJp: "アヌラーダー",           lord: "Saturn"  },
    { name: "Jyeshtha",         nameJp: "ジェーシュター",         lord: "Mercury" },
    { name: "Mula",             nameJp: "ムーラ",                 lord: "Ketu"    },
    { name: "Purva Ashadha",    nameJp: "プールヴァ・アーシャーダー", lord: "Venus"   },
    { name: "Uttara Ashadha",   nameJp: "ウッタラ・アーシャーダー",   lord: "Sun"     },
    { name: "Shravana",         nameJp: "シュラヴァナ",           lord: "Moon"    },
    { name: "Dhanishtha",       nameJp: "ダニシュター",           lord: "Mars"    },
    { name: "Shatabhisha",      nameJp: "シャタビシャー",         lord: "Rahu"    },
    { name: "Purva Bhadrapada", nameJp: "プールヴァ・バドラパダー",   lord: "Jupiter" },
    { name: "Uttara Bhadrapada",nameJp: "ウッタラ・バドラパダー",     lord: "Saturn"  },
    { name: "Revati",           nameJp: "レーヴァティー",         lord: "Mercury" },
  ];

  const NAKSHATRA_SIZE = 360 / 27; // 13.3333... degrees
  const TOTAL_PADAS = 108; // 27 nakshatras × 4 padas each

  function getNakshatra(siderealLongitude) {
    const lon = ((siderealLongitude % 360) + 360) % 360;
    // Integer arithmetic on total padas avoids floating-point pada boundaries
    // (e.g. exactly 180° landing on the wrong pada due to 13.333... precision).
    const totalPadaIdx = Math.min(TOTAL_PADAS - 1, Math.floor((lon * TOTAL_PADAS) / 360));
    const index = Math.floor(totalPadaIdx / 4) % 27;
    const pada = (totalPadaIdx % 4) + 1;
    const posInNakshatra = lon - index * NAKSHATRA_SIZE;
    const data = NAKSHATRA_DATA[index];
    return {
      index,
      pada,
      name: data.name,
      nameJp: data.nameJp,
      lord: data.lord,
      longitude: lon,
      fraction: posInNakshatra / NAKSHATRA_SIZE, // 0..1 position within nakshatra
    };
  }

  // ============================================================
  // Vimshottari Dasha (120-year planetary period system)
  // ============================================================
  const DASHA_ORDER  = ["Ketu", "Venus", "Sun", "Moon", "Mars", "Rahu", "Jupiter", "Saturn", "Mercury"];
  const DASHA_YEARS  = { Ketu: 7, Venus: 20, Sun: 6, Moon: 10, Mars: 7, Rahu: 18, Jupiter: 16, Saturn: 19, Mercury: 17 };
  const MS_PER_VEDIC_YEAR = 365.2422 * 24 * 3600 * 1000;

  function buildDashaTimeline(moonLongitude, birthDateMs) {
    const nakshatra = getNakshatra(moonLongitude);
    const firstLord = nakshatra.lord;
    const firstLordIndex = DASHA_ORDER.indexOf(firstLord);
    const elapsedFraction = nakshatra.fraction; // 0..1 of first maha dasha already elapsed

    // Virtual start = when the full first maha dasha would have started
    // (before birth, since the person was born mid-dasha)
    const firstYears = DASHA_YEARS[firstLord];
    const firstVirtualStart = birthDateMs - firstYears * elapsedFraction * MS_PER_VEDIC_YEAR;
    const firstEnd = firstVirtualStart + firstYears * MS_PER_VEDIC_YEAR;

    const dashas = [];
    dashas.push({
      lord: firstLord,
      virtualStart: firstVirtualStart,
      start: birthDateMs,      // display start = birth
      end: firstEnd,
      years: firstYears,
      balanceAtBirth: firstYears - firstYears * elapsedFraction,
    });

    let cursor = firstEnd;
    for (let i = 1; i < 9; i++) {
      const lord = DASHA_ORDER[(firstLordIndex + i) % 9];
      const years = DASHA_YEARS[lord];
      const end = cursor + years * MS_PER_VEDIC_YEAR;
      dashas.push({
        lord,
        virtualStart: cursor,
        start: cursor,
        end,
        years,
      });
      cursor = end;
    }

    return { nakshatra, dashas };
  }

  function getCurrentDasha(timeline, nowMs) {
    if (!timeline || !timeline.dashas) return null;
    const now = nowMs != null ? nowMs : Date.now();

    const currentMd = timeline.dashas.find(d => now >= d.virtualStart && now < d.end);
    if (!currentMd) return null;

    // Compute antardasha — spans the full maha dasha from its virtualStart,
    // so for the first (partially-elapsed) maha dasha the antar may have
    // already begun before birth.
    const mdLordIndex = DASHA_ORDER.indexOf(currentMd.lord);
    const mdFullYears = currentMd.years;
    let antarCursor = currentMd.virtualStart;
    for (let i = 0; i < 9; i++) {
      const antarLord = DASHA_ORDER[(mdLordIndex + i) % 9];
      const antarYears = mdFullYears * DASHA_YEARS[antarLord] / 120;
      const antarEnd = antarCursor + antarYears * MS_PER_VEDIC_YEAR;
      if (now >= antarCursor && now < antarEnd) {
        return {
          maha: {
            lord: currentMd.lord,
            start: currentMd.start,
            end: currentMd.end,
            years: currentMd.years,
          },
          antar: {
            lord: antarLord,
            start: antarCursor,
            end: antarEnd,
            years: antarYears,
          },
        };
      }
      antarCursor = antarEnd;
    }

    return {
      maha: {
        lord: currentMd.lord,
        start: currentMd.start,
        end: currentMd.end,
        years: currentMd.years,
      },
      antar: null,
    };
  }

  return {
    getRashi,
    recommend,
    recommendFromPositions,
    getNakshatra,
    buildDashaTimeline,
    getCurrentDasha,
    RASHI_DATA,
    NAKSHATRA_DATA,
    PLANET_NAMES_JP,
    PLANET_PRIORITY,
    DASHA_ORDER,
    DASHA_YEARS,
  };
})();
